import React, { FC } from 'react';
import clsx from 'clsx';

import { Heading, Types, RichText, Button, Link, eventUtil } from '@marriott/mi-ui-library';

import { ContentBlockV2Props } from '../SignInContentBlock.types';
import { addSubDirectoryPrefix, getCustomClickTrackingPageName, TRACKING_CONSTANTS } from '../../../modules/utils';
import { ACCOUNT_MODAL_CLOSE_EVENT } from '../../../modules';

// Use named rather than default exports.
export const ContentBlockV2: FC<ContentBlockV2Props> = props => {
  const { INTERNAL, JOIN_FOR_FREE, JOIN_NOW_SUBMIT, SELECT_ANOTHER_RATE_CTA } = TRACKING_CONSTANTS;
  const customClickTrackingPageName = getCustomClickTrackingPageName(props?.accountEvent?.trackingPageName);

  const redirectUrl =
    typeof window !== 'undefined' ? window.location.pathname + window.location.search + window.location.hash : '';
  const continueAsCtaTrackingValue = props?.hasTrackingPageName || props?.isFlyout
    ? `${props?.hasTrackingPageName ? props?.trackingPageName : customClickTrackingPageName}|${SELECT_ANOTHER_RATE_CTA}|${INTERNAL}|`
    : '';

  function buildJoinHref(
    path: string,
    opts: {
      enrollmentSourceCode?: string;
      signInreturnUrl?: string;
    } = {}
  ): string {
    const [base, existingQuery = ''] = path.split('?');
    const params = new URLSearchParams(existingQuery);
    opts.enrollmentSourceCode && params.set('enrollmentSourceCode', opts.enrollmentSourceCode);
    params.set('returnToUrl', opts.signInreturnUrl ? opts.signInreturnUrl : redirectUrl);
    return `${base}?${params}`;
  }

  return (
    <div className="text-content-container px-2 px-lg-0">
      {props?.contentBlockHeader && (
        <Heading
          element={Types.tags.h2}
          titleText={props?.contentBlockHeader}
          customClass={props?.contentBlockDescription ? 'mb-2' : 'mb-5'}
          variation={Types.headingType.subtitle}
          fontSize={Types.size.extraLarge}
        />
      )}
      {props?.contentBlockDescription && (
        <RichText
          text={props?.contentBlockDescription ?? ''}
          componentId={'content-block-description'}
          customClass="content-block-description t-font-m point-list mb-4"
        />
      )}
      {props?.joinNowLabel && (
        <div className="">
          <Button
            isLink={true}
            buttonCopy={props?.joinNowLabel}
            target="_self"
            href={buildJoinHref(props?.joinNowCtaPath || '', {
              enrollmentSourceCode: props?.enrollmentSourceCode,
              signInreturnUrl: props?.signInreturnUrl,
            })}
            custom_click_track_value={
              props?.isFlyout
                ? `${customClickTrackingPageName}|${JOIN_NOW_SUBMIT}|${INTERNAL}|`
                : `${props?.trackingPageName}|${JOIN_FOR_FREE}|${INTERNAL}|`
            }
            className={clsx(
              'm-button-m m-button-secondary text-center width-mobile-100 d-flex-sm justify-content-center align-items-center px-4 px-md-3',
              props?.isOverLay ? 'join-now-btn-overlay' : 'join-now-btn',
              'mb-4'
            )}
          />
        </div>
      )}
      {props?.continueAsCTALabel && (
        <div className="d-flex align-items-center">
          <Link
            target={'_self'}
            linkType="internal"
            text={props?.continueAsCTALabel}
            linkClassName="m-link-back-tertiary-button footer-container__link"
            custom_click_track_value={continueAsCtaTrackingValue}
            {...(props?.continueAsCTAPath
              ? {
                  linkHref: addSubDirectoryPrefix(props?.continueAsCTAPath),
                }
              : {
                  linkHref: '#',
                  callback: () => {
                    eventUtil.dispatch(ACCOUNT_MODAL_CLOSE_EVENT, {});
                    if (typeof window !== 'undefined') {
                      window.location.reload();
                    }
                  },
                })}
          />
        </div>
      )}
    </div>
  );
};
